export default "__VITE_ASSET__CpoxtiTi__"